import DescriptionList, {
  DescriptionListItem,
} from '~/components/DescriptionList';
import Page from '~/components/layout/page/Page';
import { EntryPoint, useLoaderData } from './shippingClaimOverview';

const titles = {
  [EntryPoint.new]: 'We received your information',
  [EntryPoint.existing]: 'A Request Already Exists',
  [EntryPoint.deepLink]: 'Request Details',
} as const satisfies Record<EntryPoint, string>;

const descriptions = {
  [EntryPoint.new]:
    "You should be receiving an email with the next steps. If you don't hear from us, please reach out at",
  [EntryPoint.existing]:
    "We found your order, but it's already had a request submitted. If you have any questions, please contact us at",
  [EntryPoint.deepLink]:
    'Here are the details of your request. If you have any questions, please contact us at',
} as const satisfies Record<EntryPoint, string>;

// TODO: use Link component
const statusMap = {
  Closed_Denied: 'Denied',
  Closed_Refunded: 'Refunded',
  Closed_Reordered: 'Reordered',
  Closed_Resolved: 'Resolved',
  InProgress: 'In Progress',
  Open: 'Open',
} as const satisfies Record<ReturnType<typeof useLoaderData>['status'], string>;

export default function ShippingClaimOverviewPage() {
  const { id, status, createdOn, entryPoint } = useLoaderData();

  return (
    <Page.Root title={titles[entryPoint]}>
      <p>
        {descriptions[entryPoint]}{' '}
        <a
          className="text-brand hover:underline"
          href="mailto:support@corso.com"
        >
          support@corso.com
        </a>
        .
      </p>
      <DescriptionList divide>
        <DescriptionListItem label="Confirmation" value={`#${id}`} />
        <DescriptionListItem label="Status" value={statusMap[status]} />
        <DescriptionListItem label="Created" value={createdOn} />
      </DescriptionList>
    </Page.Root>
  );
}
